<template>
  <div class="checkbox-grid">
    <ButtonCheckbox
      v-for="{ value, label } in options"
      :key="value"
      :value="selected.includes(value)"
      @change="onChange($event, value)"
      >{{ label }}</ButtonCheckbox
    >
  </div>
</template>

<script>
import ButtonCheckbox from '@/components/button-checkbox';
export default {
  components: { ButtonCheckbox },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onChange(isChecked, value) {
      this.$emit('change', { isChecked, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-grid {
  display: grid;
  grid-gap: 16px;
  grid-template-columns: 1fr;
  margin: 24px auto;
  width: 100%;

  @media screen and (min-width: 768px) {
    grid-gap: 32px;
    grid-template-columns: 1fr 1fr;
  }
}

.button-checkbox {
  align-items: center;
  display: flex;
  padding: 24px;

  &:hover {
    background-color: rgba(27, 7, 83, 0.15);
  }
  @media screen and (min-width: 768px) {
    min-height: 150px;
    padding: 32px;
  }
}

.button-checkbox.active {
  background: var(--gray);
}

.button-checkbox /deep/ .active-checkmark {
  height: 2.5em;
  width: 2.5em;
}
</style>
